import styled from 'styled-components';


export const DivGlobalStyled = styled.div`
  background-color: ${(props) => props.theme['background-color']};
  padding: 1% 1em;
  border-radius: 1em;
  display: flex;
  margin: 1em 50px;
  align-items: center;
  @media (max-width: 768px) {
    padding: 1em;
    margin: 1em;
  }
`;
export const DivStyled = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  @media (max-width: 768px) {
    flex-wrap: wrap;
    align-items: center;
    margin-left: 1em;
  }
  p {
    color: ${(props) => props.theme.colorText};
    text-align: left;
    font-size: 13px;
    align-items: center;
    margin-top: 1em;
    padding: 0 1em;
    max-width: 80%;
    @media (max-width: 768px) {
      max-width:100%;
      padding: 0;

    }
  }
  button {
    font-size: 13px;
    color: ${(props) => props.theme.colorText};
    font-weight: bold;
    background-color: ${(props) => props.theme.buttonColor};
    display: flex;
    justify-content: center;
    white-space: nowrap;
    align-items: center;
    border: none;
    border-radius: 1em;
    padding: 1em 3%;
    gap: 10px;
    cursor: pointer;
    @media (min-width: 768px) {
      max-width:100%;
      margin: auto;
    }  
  }
`;
